import React, { useState } from 'react';
import { sendPasswordResetEmail } from '../../helpers/auth';

export default function PasswordResetForm(props) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setStatus({ type: 'error', message: 'Please enter your email.' });
      return;
    }
    setLoading(true);
    try {
      await sendPasswordResetEmail(email);
      setStatus({
        type: 'success',
        message:
          'Reset email sent. Check your inbox for the link to set a new password.',
      });
    } catch (err) {
      setStatus({ type: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="auth-header">
        <h1 className="auth-title">Reset password</h1>
        <p className="auth-sub muted">
          Enter the email you signed up with and we'll send a link to reset
          your password.
        </p>
      </div>
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-field">
          <label htmlFor="reset-email" className="auth-label">
            Email
          </label>
          <input
            id="reset-email"
            type="email"
            className="auth-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
            autoFocus
          />
        </div>
        {status.message ? (
          <div className={`auth-alert auth-alert-${status.type || 'info'}`}>
            {status.message}
          </div>
        ) : null}
        <button
          type="submit"
          className="btn btn-grad auth-submit"
          disabled={loading}
        >
          {loading ? 'Sending…' : 'Send reset link'}
        </button>
      </form>
      <button
        type="button"
        className="auth-back-link"
        onClick={(e) => {
          e.preventDefault();
          props.onCancel();
        }}
      >
        ← Back to login
      </button>
    </>
  );
}
